export default __webpack_public_path__ + "static/media/console-sql.279804b1.svg";